export default __webpack_public_path__ + "static/media/DaviMarcos_01.8c24e5f9.jpg";